const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.665433 0.866117C1.15359 0.377961 1.94504 0.377961 2.4332 0.866117L7.79932 6.23223L13.1654 0.866117C13.6536 0.377961 14.445 0.377961 14.9332 0.866117C15.4214 1.35427 15.4214 2.14573 14.9332 2.63388L9.56708 8L14.9332 13.3661C15.4214 13.8543 15.4214 14.6457 14.9332 15.1339C14.445 15.622 13.6536 15.622 13.1654 15.1339L7.79932 9.76777L2.4332 15.1339C1.94504 15.622 1.15359 15.622 0.665433 15.1339C0.177278 14.6457 0.177278 13.8543 0.665433 13.3661L6.03155 8L0.665433 2.63388C0.177278 2.14573 0.177278 1.35427 0.665433 0.866117Z"
      fill="black"
    />
  </svg>
);

export default CloseIcon;
